import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!

  return (_openBlock(), _createBlock(_component_a_auto_complete, {
    ref: "refSelecionarProduto",
    value: _ctx.state.codigoSelecionado,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.codigoSelecionado) = $event)),
    options: _ctx.state.listaDefinicoes.map(item => ({
    value: item.codigoInterno,
    descricao: item.produto})),
    placeholder: _ctx.props.placeholder,
    disabled: _ctx.props.disabled,
    loading: _ctx.props.emDigitacao,
    "filter-option": false,
    onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.aoPesquisarOuDigitar($event))),
    onSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.aoSelecionar($event))),
    style: {"width":"100%"},
    class: _normalizeClass('ss-tamanho-completo')
  }, {
    option: _withCtx(({ value, descricao }) => [
      _createElementVNode("div", null, [
        _createElementVNode("strong", null, _toDisplayString(value), 1),
        _createTextVNode(" - " + _toDisplayString(descricao), 1)
      ])
    ]),
    _: 1
  }, 8, ["value", "options", "placeholder", "disabled", "loading"]))
}